/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

//用户统计
const userdata = require('appComp/page/userdata/userdata/userdata');
const usersurvey = require('appComp/page/userdata/user-survey/user-survey');
const vertifyData = require('appComp/page/userdata/vertify-data/vertify-data');

module.exports = {
  component: userdata,
  subRoutes: {
    "/usersurvey": {
      "component": usersurvey,
      "title": "用户统计",
    },
    "/vertifydata": {
    	"component": vertifyData,
    	"title": "认证数据"
    }
  }
}



// WEBPACK FOOTER //
// ./src/appBackend/router/userdata.js